import { PdfZoomControls } from "./PdfZoomControls";
import { usePdfZoom } from "./usePdfZoom";

interface PdfPreviewFrameProps {
  /** Presigned URL of the PDF */
  url: string;
  title: string;
}

/**
 * Renders a PDF through the Tellescope PDF preview service with zoom controls. Fills its parent's
 * height, so the parent must have a definite height.
 */
export const PdfPreviewFrame = ({ url, title }: PdfPreviewFrameProps) => {
  const pdfZoom = usePdfZoom();
  // Use dedicated PDF preview service to avoid browser download behavior
  const pdfPreviewUrl = encodeURI(`https://pdf.tellescope.com?url=${url}`);

  return (
    <div className="flex h-full flex-col gap-2">
      <PdfZoomControls {...pdfZoom} />
      <div className="min-h-0 flex-1 overflow-auto rounded-lg border">
        {/* The preview service fits each page to the iframe's width, so zooming widens the iframe and
            the pages re-render larger (and stay crisp) instead of being scaled as pixels. */}
        <iframe
          src={pdfPreviewUrl}
          title={title}
          className="mx-auto block h-full"
          style={{ width: `${pdfZoom.zoom * 100}%` }}
        />
      </div>
    </div>
  );
};
